import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import styles from './styles/styles.module.scss';
import FeedItemWrapper from '../FeedItemWrapper';
import FeedRiver from '../../FeedRiver';
import CommunityTrailCard from '../../cards/CommunityTrailCard';
import CommunityTrackCard from '../../cards/CommunityTrackCard';

const ListFeedItem = ({ user, timestamp, description, additions }) => {
  const { context } = useSelector(state => state, shallowEqual);

  const chooseAddition = (addition, idx) => {
    const resource = addition.additionData;

    switch (addition.additionType) {
      case 'trail':
        return <CommunityTrailCard context={context} idx={idx} key={`trail-${resource.ID}`} trail={resource} />;
      case 'activity':
        return <CommunityTrackCard context={context} handleCardClick={() => {}} idx={idx} track={resource} />;
      default:
        return null;
    }
  };

  const listAdditions = useMemo(() => {
    if (additions.length === 1) {
      return chooseAddition(additions[0]);
    }

    return (
      <div className={styles.container}>
        <FeedRiver>
          {additions.map((addition, idx) => {
            return chooseAddition(addition, idx);
          })}
        </FeedRiver>
      </div>
    );
  }, [additions]);

  return (
    <FeedItemWrapper user={user} timestamp={timestamp} description={description} context={context}>
      {listAdditions}
    </FeedItemWrapper>
  );
};

// Stubbed API still collecting client feedback proptypes will come when this is more consistent

export default ListFeedItem;
